module.exports = __webpack_public_path__ + "img/1.07e40613.jpg";